import React, { useEffect } from "react";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import { getPermissions } from "../rbac/hasAccess";
import { toast } from "react-toastify";
import axiosWithToken from "../../../utils/commonComponent/axiosTokenConfig";
import { validateRequiredFields } from "../../../utils/commonComponent/errorAlert";
import { BASE_URL } from "../../../global";
import { fetchQuery } from "../../../utils/commonComponent/fetched";
import Text from "../../../utils/Custom/text";
import { AutoCompletes, DateInput, TextFields } from "../../../utils/Custom/custominput";
import { CancelButton, SaveAndUpdate } from "../../../utils/Custom/Button";

const EditEnquiry = (props) => {
  const params = useParams();
  const navigate = useNavigate();
  const permissions = getPermissions(props.moduleId);
  const [inputStates, setInputStates] = React.useState({});
  const [errors, setErrors] = React.useState({});
  const [empList, setEmpList] = React.useState([]);

  const updateInputObject = (key, value) =>
    setInputStates((prev) => ({ ...prev, [key]: value }));

  const fetchData = async () => {
    const response = await fetchQuery(`select * from enquiry where id = ${params.id}`);
    setInputStates(response?.[0]);
  };

 const fetchEmployeeList = async () => {
    const query = `SELECT u.*, emp.name, emp.employeesCode, eod.hrDesignation FROM users u LEFT JOIN employees emp ON u.employeeId = emp.id LEFT JOIN employeeOtherData eod ON emp.id = eod.employeeId WHERE u.status = 1 AND eod.hrDesignation IN ('Business Development Executive','CEO','Director & Founder','Managing Director & Founder','Marketing Executive') ORDER BY u.id DESC`;
    const res = await fetchQuery(query);
    const modified = res?.map((item) => ({
      ...item,
      label: `${item.name} (${item.employeesCode})`,
    }))
    setEmpList(modified);
  };

  const onSubmit = async () => {
    const required = [
      { value: inputStates.enquiryNo, label: "Enquiry No is required" },
      { value: inputStates.enquiryDate, label: "Enquiry Date is required" },
      { value: inputStates.customerName, label: "Customer Name is required" },
      { value: inputStates.address, label: "Address is required" },
      { value: inputStates.mode_of_enquiry, label: "Mode of Enquiry is required" },
      { value: inputStates.contactPerson, label: "Contact Person is required" },
      { value: inputStates.customer_contact_number, label: "Contact Number is required" },
      { value: inputStates.customer_email_id, label: "Email is required" },
    ];
    if (!validateRequiredFields(required)) return;
    let newErrors = {};
    // Contact Number Validation
    if (inputStates.customer_contact_number && !/^\d{10}$/.test(inputStates.customer_contact_number)) {
      newErrors.customer_contact_number = "Enter a valid 10-digit mobile number";
    }
    // Email Validation
    if (inputStates.customer_email_id && !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(inputStates.customer_email_id
      )) {
      newErrors.customer_email_id = "Enter a valid email address";
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    setErrors({});

    try {
      const Url = BASE_URL + "enquiry";
      if (params.id == 0) {
        const res = await axiosWithToken.post(Url, inputStates);

        await axiosWithToken.post(BASE_URL + "enquiryHistory", {
          enquiryId: res?.data?.insertId,
          remark: inputStates.followupRemark || null,
          followupDate: inputStates.followUpDate || null,
        });
        toast.success("Enquiry Created Successfully!");
        navigate("/enquiryList");
      } else {
        await axiosWithToken.patch(Url + `/${params.id}`, inputStates);
        toast.success("Enquiry Updated Successfully!");
        setTimeout(() => window.location.reload(), 1000);
      }

    } catch (err) {
      console.error(err);
    }
  };

  const generateEnquiryNo = async () => {
    const response = await fetchQuery(`SELECT enquiryNo FROM enquiry ORDER BY id DESC LIMIT 1`);
    let enquiryNo = "DYC/1";
    if (response?.length > 0 && response[0].enquiryNo) {
      const lastNo = response[0].enquiryNo;
      const lastPart = parseInt(lastNo.substring(lastNo.lastIndexOf("/") + 1), 10);
      const fy = `${moment().subtract(1, "year").format("YY")}-${moment().format("YY")}`;
      enquiryNo = `DYC/ENQ/${fy}/${isNaN(lastPart) ? 1 : lastPart + 1}`;
    }

    setInputStates((prev) => ({ ...prev, enquiryNo }));
  };

  useEffect(() => {
    if (params.id != 0) {
      fetchData();
    } else {
      generateEnquiryNo();
    }
    fetchEmployeeList();
  }, [params.id]);

  return (
    <>
      <Text variant="h3" bold className="text-blue-600">
        {params.id == 0 ? "Create New Enquiry" : "Update Enquiry"}
      </Text>
      <br />

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        <div className="w-full">
          <TextFields
            label="Enquiry No *"
            value={inputStates.enquiryNo || ""}
            onChange={(e) => updateInputObject("enquiryNo", e.target.value)}
            disabled
          />
        </div>

        <div className="w-full">
        <DateInput
          id={"enquiryDate"}
          label={"Enquiry Date"}
          value={inputStates.enquiryDate || null}
          onChange={(value) => updateInputObject("enquiryDate", value)}
          maxDate={new Date()}
        />
        </div>

        <div className="w-full">
          <TextFields
            label="Customer Name *"
            value={inputStates.customerName || ""}
            onChange={(e) => updateInputObject("customerName", e.target.value)}
          />
        </div>

        <div className="w-full">
          <TextFields
            label="Address *"
            value={inputStates.address || ""}
            onChange={(e) => updateInputObject("address", e.target.value)}
          />
        </div>

        <div className="w-full">
          <AutoCompletes
            label="Mode of Enquiry *"
            options={[
              { id: 1, label: "Visit" },
              { id: 2, label: "Customer Call" },
              { id: 3, label: "Telephone" },
              { id: 4, label: "Website" },
              { id: 5, label: "Referral" },
              { id: 6, label: "Social Media" },
            ]}
            value={inputStates.mode_of_enquiry}
            onChange={(val) => {
              updateInputObject("mode_of_enquiry", val);
            }}
            isWidth
            valueKey="label"
            labelKey="label"
          />
        </div>

        <div className="w-full">
          <TextFields
            label="Contact Person *"
            value={inputStates.contactPerson || ""}
            onChange={(e) => updateInputObject("contactPerson", e.target.value)}
          />
        </div>

        <div className="w-full">
          <TextFields
            label="Customer Contact Number *"
            value={inputStates.customer_contact_number || ""}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "").slice(0, 10);
              updateInputObject("customer_contact_number", value);
              setErrors((prev) => ({...prev, customer_contact_number: ""}));
            }}
            error={!!errors.customer_contact_number}
            helperText={errors.customer_contact_number}
          />
        </div>

        <div className="w-full">
          <TextFields
            label="Customer Email ID *"
            value={inputStates.customer_email_id || ""}
            onChange={(e) => {
              updateInputObject("customer_email_id", e.target.value);
              setErrors((prev) => ({...prev, customer_email_id: ""}));
            }}
            error={!!errors.customer_email_id}
            helperText={errors.customer_email_id}
          />
        </div>

        <div className="w-full">
          <TextFields
            label="Services Offer"
            value={inputStates.services_offer || ""}
            onChange={(e) =>
              updateInputObject("services_offer", e.target.value)
            }
          />
        </div>

        <div className="w-full">
          <TextFields
            label="Enquiry Item"
            value={inputStates.enquiry_item || ""}
            onChange={(e) => updateInputObject("enquiry_item", e.target.value)}
          />
        </div>

        <div className="w-full">
          <TextFields
            label="Domain"
            value={inputStates.domain || ""}
            onChange={(e) => updateInputObject("domain", e.target.value)}
          />
        </div>

        <div className="w-full">
          <TextFields
            label="DYC Client Code"
            value={inputStates.dyc_client_code || ""}
            onChange={(e) =>
              updateInputObject("dyc_client_code", e.target.value)
            }
          />
        </div>

        <div className="w-full">
          <TextFields
            label="Service Requirement"
            value={inputStates.service_requirement || ""}
            onChange={(e) =>
              updateInputObject("service_requirement", e.target.value)
            }
          />
        </div>

        <div className="w-full">
          <AutoCompletes
            label="Reviewed By"
            options={empList}
            value={empList.find((emp) => emp.id == inputStates.reviewedBy)}
            onChange={(val) => {
              updateInputObject("reviewedBy", val);
            }}
            isWidth
            valueKey="id"
            labelKey="label"
          />
        </div>

        <div className="w-full">
          <AutoCompletes
            label="Reviewed By Technical & BD"
            options={empList}
            value={empList.find((emp) => emp.id == inputStates.enquiry_review)}
            onChange={(val) => {
              updateInputObject("enquiry_review", val);
            }}
            isWidth
            valueKey="id"
            labelKey="label"
          />
        </div>
        
        <div className="w-full">
        <DateInput
          id={"followUpDate"}
          label={"Follow Up Date"}
          value={inputStates.followUpDate || null}
          onChange={(value) => updateInputObject("followUpDate", value)}
          disabled={params.id != 0}
          />
        </div>

        <div className="w-full">
          <TextFields
            label="Follow Up Remark"
            value={inputStates.followupRemark || ""}
            onChange={(e) =>
              updateInputObject("followupRemark", e.target.value)
            }
            disabled={params.id != 0}
          />
        </div>
      </div>

      <div className="flex gap-10 mt-5 justify-end">
        <CancelButton
          id="btn-cancel"
          label="Cancel"
          outline
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?")) {
              window.history.back();
            }
          }}
        />
        {(permissions.save || permissions.create || permissions.allAccess) && (
          <SaveAndUpdate id="btn-add-outline" label="Save" onClick={onSubmit} />
        )}
      </div>
    </>
  );
};

export default EditEnquiry;
